import { cloneElement, MouseEvent as ReactMouseEvent, ReactElement } from 'react';
import { ButtonProps } from '@mui/material';
import { useConnectModal, useWagmiAuth } from 'app/providers';
import { defaultChain } from 'shared/config/wagmi';
import { useSupportedChains } from 'shared/hooks';
import { SwitchNetworkButton } from 'shared/ui/buttons/switch-network-button';

export type NetworkGuardedButtonProps = {
  children: ReactElement<ButtonProps>;
  targetChainId?: number;
} & Omit<ButtonProps, 'onClick' | 'onError' | 'children'>;

export const NetworkGuardedButton = ({ children, targetChainId, ...props }: NetworkGuardedButtonProps) => {
  const { state: authState } = useWagmiAuth();

  const { isSupported, chainId } = useSupportedChains();
  const { open } = useConnectModal();

  if (!authState.isAuthorized || !authState.address) {
    return cloneElement(children, {
      onClick: async (e: ReactMouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        open?.();
      },
      ...props,
      disabled: false,
      type: 'button',
    });
  }

  if (!isSupported || (targetChainId && chainId !== targetChainId)) {
    return <SwitchNetworkButton chainId={targetChainId ?? defaultChain.id} {...props} disabled={false} type="button" />;
  }

  return cloneElement(children, props);
};
